<template lang="pug">
v-dialog(v-model="show" max-width="375" persistent hide-overlay)
  v-sheet.rounded-xl.px-8.py-10(style="position: relative")
    p.text-h3.font-weight-bold.mb-5.text-center {{ $t("пользовательское_соглашение_обновлено") }}
    p.text-subtitle-1.mb-4.text-center {{ $t("для_продолжения_работы_в_rekassa_ознакомьтесь_с_пользовательским_соглашением") }}

    p.text-center
      a.mb-4.text-subtitle-1(@click="openAgreementLink") {{ $t("ознакомиться_с_пользовательским_соглашением") }}

    v-checkbox.mb-4(v-model="agreed" :label="$t('я_ознакомлен_с_пользовательским_соглашением_и_принимаю_условия')" color="success" hide-details)

    v-btn.text-h5.font-weight-bold.mt-8.mb-2(color="primary" block :disabled="!agreed" :loading="loading" @click="accept") {{ $t("принять_и_продолжить") }}

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { DIALOG_PRIORITIES } from '../../utils/dialogPriorities'

const DIALOG_ID = 'rek-agreement'

export default {
  name: 'AgreementNotifier',
  data: () => ({
    dialog: false,
    agreed: false,
    loading: false,
    curtainElement: null,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),

    ...mapGetters('dialogQueue', ['isActive']),

    show() {
      return this.dialog && this.isActive(DIALOG_ID)
    },
  },

  watch: {
    show(value) {
      if (value) {
        this.createCurtain()
      } else {
        this.removeCurtain()
      }
    },

    dialog(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.releaseDialog(DIALOG_ID)
      }
    },
  },

  created() {
    this.checkAgreement()
  },

  beforeDestroy() {
    this.removeCurtain()
    const allCurtains = document.querySelectorAll('.re-agreement-notifier-curtain')
    allCurtains.forEach(curtain => curtain.remove())
    this.releaseDialog(DIALOG_ID)
  },

  methods: {
    ...mapActions({
      setAgreementSeen: 'auth/setAgreementSeen',
      requestDialog: 'dialogQueue/request',
      releaseDialog: 'dialogQueue/release',
    }),

    checkAgreement() {
      if (!this.user.registrationDate) return
      // Отображать только для пользователей, зарегистрированных до 22.04.2026 включительно
      if (this.$moment(this.user.registrationDate).isSameOrAfter('2026-04-22')) return
      if (this.user.settings?.agreementSeenDate != null) return

      this.dialog = true
      this.requestDialog({ id: DIALOG_ID, priority: DIALOG_PRIORITIES.AGREEMENT })
    },

    createCurtain() {
      this.$nextTick(() => {
        const existingCurtains = document.querySelectorAll('.re-agreement-notifier-curtain')
        existingCurtains.forEach(curtain => curtain.remove())

        const curtain = document.createElement('div')
        curtain.classList.add('re-agreement-notifier-curtain')
        curtain.style.position = 'fixed'
        curtain.style.top = '0'
        curtain.style.left = '0'
        curtain.style.width = '100%'
        curtain.style.height = '100%'
        curtain.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'

        this.curtainElement = curtain

        const mainWrap = document.querySelector('.v-main__wrap')
        if (mainWrap) {
          mainWrap.appendChild(curtain)
        } else {
          document.body.appendChild(curtain)
        }
      })
    },

    openAgreementLink() {
      const { locale } = this.$i18n
      const url = `https://link.rekassa.kz/app-agreement${locale === 'ru' ? '' : '-kk'}`
      this.$openLink(url, '_system')
    },

    accept() {
      this.loading = true
      this.setAgreementSeen().then(() => {
        this.dialog = false
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    removeCurtain() {
      if (this.curtainElement && this.curtainElement.parentNode) {
        this.curtainElement.remove()
        this.curtainElement = null
      }
    },
  },
}
</script>
